import React, { useEffect, useState, useRef, useCallback } from "react";
import search from "../../Assets/Tutor/searchIconGray.svg";
import schoolIocn from "../../Assets/School/schoolIocn.svg";
import TutorImg from "../../Assets/Tutor/TutorImg.svg";
import themeParkIcon from "../../Assets/SideBar/themeParkActive.svg";
import universityIcon from "../../Assets/University/universityIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API_END_POINTS,
  AUTHENTICATION,
  FILTER_CONSTANT,
  GLOBAL_CONSTANTS,
  ROUTES,
} from "../../Constants/Constants";
import { axiosInstance } from "../../Utilities/Interceptor/Interceptor";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { store } from "../../Redux/Store/Store";
import { setLoader, setLoginSignUpOpen, setSchoolFilter } from "../../Redux/Reducer/Reducer";
import {
  GetSessionStorageData,
  SetSessionStorageData,
  encryptPassData,
  isObjectEmptyValue,
  nullUndefinedEmptyCheck,
} from "../../Utilities/Helpers/Helper";
import ExpandMap from "../../Assets/Activities/ExpandMap.svg";
import activitiesIcon from "../../Assets/Activities/activitiesIcon.svg";
import schoolImg from "../../Assets/School/schoolImg.svg";
import LikeIcon from "../../Assets/School/schoolLikeIcon.svg";
import ShareIcon from "../../Assets/School/shareIcon.svg";
import locationIcon from "../../Assets/Tutor/location.svg";
import "./SchoolDashboardLayout";
import SchoolMaps from "../../Components/SchoolMaps/SchoolMaps";
import toast from "react-hot-toast";
import SchoolFill from "../../Assets/HeartFill/SchoolFill.svg";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { useMediaQuery, useTheme } from "@mui/material";
import WebShareComponent from "../../Components/WebShare/WebShare";
import AppFilter from "../../Components/AppFilter.tsx/AppFilter";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";


const SchoolDashboardLayout = () => {
  const school_search = GetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.SCHOOL);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(768)); 

  const containerStyle: React.CSSProperties = isMobile
    ? {
        width: "100%",
        minHeight: "200px",
        maxHeight: "400px",
        height: "40vh",
      }
    : {
        width: "100%",
        minHeight: "235px",
        maxHeight: "800px",
        height: "100vh",
      };

  const isLoaded: boolean = useSelector((state: any) => state.googleMapLoadedReducer?.isGoogleMapLoaded);
  const [searchValue, setSearchValue] = useState(school_search ? school_search : "");
  const [schoolList, setschoolList] = useState<any[]>([]);
  const [list, setList] = useState<any[]>([]);
  const [searchTextList, setSearchTextList] = useState([]);
  const [currentLat, setCurrentLat] = useState<any>("");
  const [currentLng, setCurrentLng] = useState<any>("");
  const [page, setPage] = useState(1); 
  const [totalPages, setTotalPages] = useState(0); 
  const [isFetching, setIsFetching] = useState(false); 
  const { t } = useTranslation();
  const limit = 10; 

  const listRef = useRef<HTMLDivElement>(null); 

  const getSchoolFilter: any = useSelector((state: any) => {
    return state.filterReducer?.schoolfilter;
  });

  const init_Schoolfilter: any = useSelector((state: any) => {
    return state.initFilterReducer.initSchoolfilter;
  });

  
  const init_filter = {
    rating: [],
    price: [0, 0],
    curriculum: [],
    radius: 10,
    grade: [0, 15],
  };
  const [FilterPopOpen, setFilterPopOpen] = useState(false);
  const [FilterData, setFilterData] = useState<any>([]);
  const [FilterApplyData, setFilterApplyData] = useState<any>(init_filter);
  const [radius, setRadius] = useState(init_filter.radius);
  const [initFilter, setInitFilter] = useState<any>(
    isObjectEmptyValue(init_Schoolfilter) ? init_Schoolfilter : init_filter
  );
  const [initSort, setSort] = useState<any>({
    price: "",
    rating: "",
  });

  const onOpenFilterPop = () => {
    setFilterPopOpen(true);
  };

  const onCloseFilterPop = () => {
    setFilterPopOpen(false);
  };

  
  const handleRouteMap = () => {
    navigate(ROUTES.SCHOOL_MAPS_VIEW, {
      state: {
        school_list: schoolList,
        search_text: searchValue,
        redius: FilterApplyData.radius,
        lat: currentLat,
        lang: currentLng,
        filter: FilterApplyData,
      },
    });
  };
  useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  const navigateSchoolDetailedView = (value: any) => {
    navigate(ROUTES.SCHOOL_DETAILE_VIEW + "?id=" + encryptPassData(value?.id), {
      state: { tutor_Detailes: value },
    });
  };

  const HeaderLoction: any = useSelector((state: any) => {
    return state.locationReducer.location;
  });

  const payload = (
    latitude: any,
    longitude: any,
    value: string,
    filter: any,
    page: number,
    limit: number
  ) => {
    var priceValue: any = [];
    var gradeValue: any = [];
    if (initFilter.price[0] === filter.price[0] && initFilter.price[1] === filter.price[1]) {
      priceValue = [];
    }
    else if (filter.price[0] === 0 && filter.price[1] === 0) {
      priceValue = []
    } else {
      priceValue = {
        min: filter.price[0],
        max: filter.price[1],
      };
    }
    if (initFilter.grade[0] === filter.grade[0] && initFilter.grade[1] === filter.grade[1]) {
      gradeValue = [];
    } else {
      gradeValue = {
        min: filter.grade[0],
        max: filter.grade[1],
      };
    }

    const sanitizedCurriculum = filter.curriculum?.filter(Boolean).map((c: string) => {
      try {
        const cleaned = c.trim().normalize('NFKD').replace(/[^\x00-\x7F]/g, '');
        return encodeURIComponent(cleaned);
      } catch {
        return '';
      }
    }).filter(Boolean) || [];

    let sanitizedSearch = "";
    try {
      if (value) {
        const cleaned = value.trim().normalize('NFKD').replace(/[^\x00-\x7F]/g, '');
        sanitizedSearch = encodeURIComponent(cleaned);
      }
    } catch (err) {
      console.warn('Invalid search value detected:', err);
    }

    const sanitizedPayload = {
      latitude: latitude?.toString() || "",
      longitude: longitude?.toString() || "",
      radius: filter.radius,
      search: sanitizedSearch,
      price: priceValue,
      rating: filter.rating || [],
      curriculum: sanitizedCurriculum,
      grade: gradeValue,
      page,
      limit
    };

    return sanitizedPayload;
  };

  const SchoolListApi = useCallback((
    latitude: any,
    longitude: any,
    value: string,
    filter: any,
    page: number,
    limit: number,
    append: boolean = true 
  ) => {
    if (isFetching) return; 
    setIsFetching(true);
    const pay = payload(latitude, longitude, value, filter, page, limit);
    axiosInstance
      .post(`${API_END_POINTS.SCHOOLLIST}`, pay)
      .then((Response: any) => {
        const data = Response?.data?.result?.data || [];
        const totalPageCount = Response?.data?.result?.total_page || 0;
        setTotalPages(totalPageCount);

        if (append) {
          
          setList(prev => [...prev, ...data]);
          if (initSort?.price || initSort?.rating) {
            handleProceedSort(initSort?.price, initSort?.rating, [...list, ...data]);
          } else {
            setschoolList(prev => [...prev, ...data]);
          }
        } else {
          
          setList(data);
          if (initSort?.price || initSort?.rating) {
            handleProceedSort(initSort?.price, initSort?.rating, data);
          } else {
            setschoolList(data);
          }
        }
      })
      .catch((error: any) => {
        console.error('Error fetching schools:', error);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [initSort, list, isFetching]);

  useEffect(() => {
    if (nullUndefinedEmptyCheck(HeaderLoction?.lat && HeaderLoction?.lng)) {
      setCurrentLat(HeaderLoction?.lat);
      setCurrentLng(HeaderLoction?.lng);
      const filter = getSchoolFilter && isObjectEmptyValue(getSchoolFilter) ? getSchoolFilter : FilterApplyData;
      setPage(1); 
      SchoolListApi(HeaderLoction?.lat, HeaderLoction?.lng, searchValue, filter, 1, limit, false);
    }
  }, [HeaderLoction]);

  useEffect(() => {
    getFilterData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!listRef.current || isFetching || page >= totalPages) return;
      const { scrollTop, scrollHeight, clientHeight } = listRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 5) { 
        setPage(prevPage => {
          const nextPage = prevPage + 1;
          if (nextPage <= totalPages) {
            SchoolListApi(currentLat, currentLng, searchValue, FilterApplyData, nextPage, limit);
          }
          return nextPage;
        });
      }
    };

    const listElement = listRef.current;
    if (listElement) {
      listElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (listElement) {
        listElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [currentLat, currentLng, searchValue, FilterApplyData, page, totalPages, isFetching, SchoolListApi]);

  const searchKeyword = (search: any) => {
    const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
    const payload = {
      search_text: encodeURIComponent(search),
      latitude: `${currentLat}`,
      longitude: `${currentLng}`,
      radius: radius,
    };
    axiosInstance
      .post(`${API_END_POINTS.SCHOOL_KEY_WORD_SEARCH}`, payload)
      .then((Response: any) => {
        setSearchTextList(Response?.data.result?.data);
      })
      .catch((error: any) => {
        console.error('Error fetching search keywords:', error);
      });
  };

  const getFilterData = () => {
    axiosInstance
      .get(`${API_END_POINTS.SCHOOLFILTERLIST}`)
      .then((Response: any) => {
        if (Response?.data?.status) {
          let data = Response?.data?.result?.data;
          setFilterData(data);
          if (data) {
            let init = {
              price: [data.price?.min, data.price?.max],
              grade: [data.grade?.min, data.grade?.max],
              rating: [],
              curriculum: [],
              radius: 10,
            };
            setInitFilter(init);
            SetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.SCHOOL, JSON.stringify(init));
            if (getSchoolFilter && isObjectEmptyValue(getSchoolFilter)) {
              setFilterApplyData(getSchoolFilter);
              setRadius(getSchoolFilter.radius);
            } else {
              setFilterApplyData(init);
            }
          }
        }
      })
      .catch((error: any) => {
        console.error('Error fetching filter data:', error);
      });
  };

  const FilterApply = (filter_data: any) => {
    setFilterApplyData(filter_data);
    setRadius(filter_data.radius);
    SetSessionStorageData(FILTER_CONSTANT.STATE_FILTER.SCHOOL, JSON.stringify(filter_data));
    store.dispatch(setSchoolFilter(filter_data));
    setPage(1); 
    SchoolListApi(currentLat, currentLng, searchValue, filter_data, 1, limit, false);
  };

  const onInputChange = (value: any) => {
    store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
    if (nullUndefinedEmptyCheck(value)) {
      setSearchValue(value);
      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.SCHOOL, value);
      if (value?.length > 2) {
        searchKeyword(value);
      }
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setPage(1); 
    SchoolListApi(currentLat, currentLng, searchValue, FilterApplyData, 1, limit, false);
  };

  const handleChangeFavourites = (val: any, id: any) => {
    const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
    if (nullUndefinedEmptyCheck(accessToken)) {
      const payload = {
        service_provider_type: GLOBAL_CONSTANTS.INITIAL_VALUES.FOUR_INT,
        service_provider: id,
        is_favourite: !val,
      };
      axiosInstance
        .post(`${API_END_POINTS.FAVOURITE__ADD}`, payload)
        .then((Response: any) => {
          if (Response?.data?.status) {
            setPage(1); 
            SchoolListApi(currentLat, currentLng, searchValue, FilterApplyData, 1, limit, false);
            toast.success(Response?.data?.message, {
              position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
            });
          }
        })
        .catch((error: any) => {
          console.error('Error updating favourites:', error);
        });
    } else {
      dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
    }
  };

  const Loader: any = useSelector((state: any) => {
    return state.loaderReducer.loader;
  });

  const handlePassListPage = (value: any) => {
    if (nullUndefinedEmptyCheck(value)) {
      if (value?.includes("near me")) {
        navigate(ROUTES.SCHOOL_LIST_VIEW, {
          state: {
            school_list: schoolList,
            search_text: value,
            redius: FilterApplyData.radius,
            lat: currentLat,
            lang: currentLng,
            map_show: true,
            filter: FilterApplyData,
          },
        });
      } else {
        navigate(ROUTES.SCHOOL_LIST_VIEW, {
          state: {
            school_list: schoolList,
            search_text: value,
            redius: FilterApplyData.radius,
            lat: currentLat,
            lang: currentLng,
            map_show: false,
            filter: FilterApplyData,
          },
        });
      }
    } else {
      setPage(1); 
      SchoolListApi(currentLat, currentLng, value, FilterApplyData, 1, limit, false);
    }
  };

  const [sortPrice, setSortPrice] = useState("");
  const [sortRating, setSortRating] = useState("");

  const sort: any = GetSessionStorageData("sort");
  useEffect(() => {
    let data = JSON.parse(sort);
    if (data?.price || data?.rating) {
      handleProceedSort(data?.price, data?.rating);
    }
  }, [sort]);

  const handleProceedSort = (checkedPrice: any, checkedRating: any, data: any = null) => {
    const sortedData = data ? [...data] : [...list];

    if (checkedPrice === "high") {
      sortedData.sort((a: any, b: any) => b?.least_fee - a?.least_fee);
    } else if (checkedPrice === "low") {
      sortedData.sort((a: any, b: any) => a?.least_fee - b?.least_fee);
    } else if (checkedRating === "high") {
      sortedData.sort((a: any, b: any) => b?.dsip_sort_rating - a?.dsip_sort_rating);
    } else if (checkedRating === "low") {
      sortedData.sort((a: any, b: any) => a?.dsip_sort_rating - b?.dsip_sort_rating);
    }
    setschoolList(sortedData);
    setSort({
      price: checkedPrice,
      rating: checkedRating,
    });
  };

  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

 
  const Ssearch_Button = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "ssearch_button_english" : "ssearch_button_arab";
  const RowOverRideSchool = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "row-override-school" : "row-override-school_arab";
  const handleNavigate = (route: string, routeName: string) => {
    console.log(`Navigating to ${routeName} with route: ${route}`);
    navigate(route);
  };

  return (
    <>
      <div className="University__dashboard__container">
        <div className="row">
          <div className="col-12 title_container">
            {isMobile ? (
              <Swiper
                slidesPerView="auto"
                spaceBetween={10}
                navigation={false}
                scrollbar={{ draggable: false }}
                modules={[Navigation, Scrollbar]}
                className="nav-swiper"
                style={{ overflow: "hidden" }}
              >
                <SwiperSlide style={{ width: "auto" }}>
                  <div className="Dashboard__schoolCard_Img_wapper">
                    <img draggable="false" src={schoolIocn} alt="SchoolImg" width={24} height={24} />
                    <div className="text">{t("Schools")}</div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ width: "auto" }}>
                  <button
                    className="nav-button gap-2"
                    onClick={() => handleNavigate(ROUTES.TUTORS, "Tutors")}
                    title={t("Tutors")}
                  >
                    <img draggable="false" src={TutorImg} alt="TutorImg" className="slider_images" />
                    <span className="nav-title" style={{ fontSize: '10px' }}>{t("Tutors")}</span>
                  </button>
                </SwiperSlide>
                <SwiperSlide style={{ width: "auto" }}>
                  <button
                    className="nav-button gap-2"
                    onClick={() => handleNavigate(ROUTES.ACTIVITYLAYOUT, "Activities")}
                    title={t("Activities")}
                  >
                    <img draggable="false" src={activitiesIcon} alt="Activities" className="slider_images" />
                    <span className="nav-title" style={{ fontSize: '10px' }}>{t("Activities")}</span>
                  </button>
                </SwiperSlide>
                <SwiperSlide style={{ width: "auto" }}>
                  <button
                    className="nav-button gap-2"
                    onClick={() => handleNavigate(ROUTES.THEMEPARK__HOMEPAGE, "Parks & Events")}
                    title={t("Parks & Events")}
                  >
                    <img draggable="false" src={themeParkIcon} className="slider_images" alt="ParksAndEventIcon" />
                    <span className="nav-title" style={{ fontSize: '10px' }}>{t("Parks & Events")}</span>
                  </button>
                </SwiperSlide>
                <SwiperSlide style={{ width: "auto" }}>
                  <button
                    className="nav-button gap-2"
                    onClick={() => handleNavigate(ROUTES.UNIVERSITYLAYOUT, "Universities")}
                    title={t("Universities")}
                  >
                    <img draggable="false" src={universityIcon} alt="Universities" className="slider_images" />
                    <span className="nav-title" style={{ fontSize: '10px' }}>{t("Universities")}</span>
                  </button>
                </SwiperSlide>
              </Swiper>
            ) : (
              <div className="Dashboard__schoolCard_Img_wapper">
                <img draggable="false" src={schoolIocn} alt="SchoolImg" />
                <div className="text">{t("Schools")}</div>
              </div>
            )}
          </div>
          <div className={`row mb-2 ${RowOverRideSchool}`}>
            <div className="col-lg-4 col-md-12 input-style-phone">
              <div className="search_field_wrapper">
                <div className="search__autocomplete">
                  <form onSubmit={handleSubmit}>
                    <Autocomplete
                      freeSolo
                      popupIcon
                      id="free-solo-2-demo"
                      disableClearable={false}
                      value={searchValue}
                      clearIcon={false}
                      onChange={(e, value) => {
                        const trimedvalue = value ? value.trim() : "";
                        setSearchValue(trimedvalue);
                        handlePassListPage(trimedvalue);
                        SetSessionStorageData(
                          FILTER_CONSTANT.SEARCH_STATE.SCHOOL,
                          trimedvalue
                        );
                      }}
                      options={searchTextList?.map(
                        (option: any) =>
                          language === "English"
                            ? option?.school_name
                            : option?.arabic_school_name || option?.school_name
                      )}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ px: 0.5, py: 0.7 }}
                          {...props}
                          className="notranslate"
                          translate="no"
                        >
                          {option}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={t("Search for School")}
                          onChange={(inputChangeEvent: any) => {
                            onInputChange(inputChangeEvent.target.value.trim());
                          }}
                          onKeyDown={(e: any) => {
                            if (e.key === GLOBAL_CONSTANTS.INITIAL_VALUES.ENTER) {
                              e.preventDefault();
                              const trimedvalue = searchValue.trim();
                              if (trimedvalue) handlePassListPage(trimedvalue);
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            type: "text",
                          }}
                        />
                      )}
                    />
                    <img
                      draggable="false"
                      src={search}
                      alt="search"
                      className={`${Ssearch_Button} search_button`}
                      onClick={() => handlePassListPage(searchValue)}
                    />
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <AppFilter
                FilterPopOpen={FilterPopOpen}
                onOpenPop={onOpenFilterPop}
                onClosePop={onCloseFilterPop}
                FilterData={FilterData}
                FilterApply={FilterApply}
                FilterApplyData={FilterApplyData}
                initFilter={initFilter}
                initSort={initSort}
                handleApplySort={handleProceedSort}
                type="school"
                color="#FFC812"
              />
            </div>
          </div>

          <div className="body_scroll_container">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="University_map_view">
                <div className="University__viewMap" onClick={handleRouteMap}>
                  <img src={ExpandMap} alt="ExpandMap" />
                  <span>{t("View on Map")}</span>
                </div>
                {/* Render map only when API is loaded and we have coordinates to avoid blank area */}
                {isLoaded && currentLat && currentLng ? (
                  <SchoolMaps
                    zoom={12}
                    radius={FilterApplyData.radius * 1000}
                    lat={currentLat}
                    lang={currentLng}
                    containerStyle={containerStyle}
                    disable={true}
                    zoomControl={false}
                    clickableIcons={false}
                    draggable={true}
                    initSort={initSort}
                    UniversityList={schoolList}
                    getOneTutor={[]}
                    filter={isObjectEmptyValue(getSchoolFilter) ? getSchoolFilter : FilterApplyData}
                    initFilter={initFilter}
                    searchValue={searchValue}
                    language={language}
                  />
                ) : (
                  <div style={{ height: containerStyle.height, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div>{isLoaded ? t("Waiting for location...") : t("Loading map... Please ensure Google Maps API is available.")}</div>
                  </div>
                )}
              </div>
            </div>
            <div
              className="col-xl-6 col-lg-6 col-md-12 col-sm-12 university__list__container"
              ref={listRef}
              style={{ overflowY: "auto", height: "650px" }} 
            >
              {schoolList.map((item: any, i: any) => (
                <div
                  className="school__list__wapper"
                  key={i}
                  onClick={() => navigateSchoolDetailedView(item)}
                >
                  <div className="university__leftside">
                    <img
                      src={
                        item?.images?.length > 0
                          ? item?.images[0]
                          : schoolImg
                      }
                      alt="schoolImg"
                      onError={(e: any) => {
                        e.target.src = schoolImg;
                      }}
                    />
                  </div>
                  <div className="university__rightside">
                    <div className="university__name">
                      <span className="notranslate name" translate="no">
                        {language === "English"
                          ? item?.school_name
                          : item?.arabic_school_name || item?.school_name}
                      </span>
                      <div
                        className="imageIcon"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <WebShareComponent
                          params={
                            ROUTES.SCHOOL_DETAILE_VIEW +
                            "?id=" +
                            encryptPassData(item?.id)
                          }
                        >
                          <img src={ShareIcon} alt="" className="mb-1" />
                        </WebShareComponent>
                        <img
                          src={item.is_favourite ? SchoolFill : LikeIcon}
                          alt=""
                          onClick={() =>
                            handleChangeFavourites(item.is_favourite, item?.user)
                          }
                        />
                      </div>
                    </div>

                    <div className="university__location">
                      <img src={locationIcon} alt="" />
                      <span className="location">
                        {item?.city ? item?.city : item.address}
                      </span>
                    </div>

                    <div className="row">
                      <div className="col-md-6 col-sm-12 university__ranking university-curiculam">
                        <div className="text__black">{t("Curriculum")} : </div>
                        <div
                          className="text__green"
                          title={item?.curriculam}
                        >
                          {item?.curriculam
                            ? item?.curriculam
                            : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 university__ranking university-curiculam">
                        <div className="text__black">
                          {t(item?.is_type ? "Year" : "Grade")} :
                        </div>
                        <div className="text__green" title={item?.grade}>
                          {item?.grade ? item?.grade : "--"}
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 marginTop university__ranking university-fees">
                        <div className="text__black">{t("Founded")} :</div>
                        <div className="text__green">
                          {item?.founded_year
                            ? item?.founded_year
                            : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 marginTop university__ranking university-fees">
                        <div className="text__black">{t("Average Fee")} : </div>
                        <div className="text__green">
                          {item?.fees_structure?.["Average Fee"] ??
                            GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                        </div>
                      </div>
                    </div>
                    <div className="university__rating">
                      <div className="text__black">{t("Rating")} : </div>
                      <div className="text__green">
                        {item?.dsip_rating
                          ? item?.dsip_rating
                          : GLOBAL_CONSTANTS.INITIAL_VALUES.NA}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {isFetching && (
                <div className="loading-more">
                  <div className="text">{t("Loading more schools...")}</div>
                </div>
              )}
              {schoolList?.length === 0 && !Loader && !isFetching && (
                <div className="No__data__contant">
                  <div className="text">{t("No Data Found")}</div>
                </div>
              )}
              {schoolList?.length > 0 && page >= totalPages && !isFetching && (
                <div className="No__data__contant">
                  <div className="text">{t("No more schools to load")}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SchoolDashboardLayout;